import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { registerOrganizationMember } from "../../store/iam/operations";
import { userIsLoggingIn } from "../../store/iam/selectors";
import { RegisterOrganizationMemberForm } from "../../components/auth";

function RegisterOrganizationMember({ token, isLoading, registerOrganizationMember }) {
    const navigate = useNavigate();
    const [shouldResetCaptcha, setShouldResetCaptcha] = useState(false);

    const onError = () => {
        setShouldResetCaptcha(true);
    };

    const submitForm = (firstName, lastName, password, recaptchaToken) => {
        setShouldResetCaptcha(false);
        registerOrganizationMember(token, firstName, lastName, password, recaptchaToken, onError, navigate);
    };

    return (
        <RegisterOrganizationMemberForm
            onSubmit={submitForm}
            isLoading={isLoading}
            push={navigate}
            shouldResetCaptcha={shouldResetCaptcha}
        />
    );
}

const mapStateToProps = (state) => ({
    isLoading: userIsLoggingIn(state)
});

export default connect(mapStateToProps, { registerOrganizationMember })(RegisterOrganizationMember);
